import SuperRepository from '../superRepository'

export default new (class UsersRepository extends SuperRepository {
  baseUri() {
    return 'user'
  }

  getSessions = async id => this.httpClient().get(`${this.baseUri()}/${id}/sessions`)
  deleteSessions = async sessionId =>
    this.httpClient().delete(`${this.baseUri()}/${sessionId}/delete_sessions`)
  loginAs = async id => this.httpClient().get(`${this.baseUri()}/${id}/impersonate`)
  getAuthLog = async params => this.httpClient().get('auth_log', params)
})()